import { adminConstants } from './../constants/admin.constants'

const initialState = {
	loading: false,
	moveflexPoints: null,
	moveflexPointsWasLoaded: false
}

export default function adminReducer(state = initialState, action) {
	switch (action.type) {
		case adminConstants.FAIL_INACTIVATE:
			return { ...state, loading: false }

		case adminConstants.INACTIVATE_CLIENT:
			return { ...state, loading: true }

		case adminConstants.SUCCESS_INACTIVATE:
			return { ...state, loading: false }

		case adminConstants.LOADING_POINTS:
			return { ...state, moveflexPointsWasLoaded: false }

		case adminConstants.POINTS_WAS_LOADED:
			return { ...state, moveflexPointsWasLoaded: true }

		case adminConstants.GET_BALANCE_POINTS:
			return { ...state, moveflexPoints: action.payload }

		case adminConstants.ADD_VIEW_BALANCE_POINTS:
			return {
				...state,
				moveflexPoints: state.moveflexPoints + +action.payload
			}

		default:
			return state
	}
}
